// extracted by mini-css-extract-plugin
export var backdrop = "ReviewItem-module--backdrop--03ba2";
export var backdropOpen = "ReviewItem-module--backdropOpen--056a9";
export var closeIcon = "ReviewItem-module--closeIcon--55064";
export var divider = "ReviewItem-module--divider--2f4bd";
export var fontColor = "ReviewItem-module--fontColor--09722";
export var playIcon = "ReviewItem-module--playIcon--05c05";
export var reviewContent = "ReviewItem-module--reviewContent--2088f";
export var reviewContentContainer = "ReviewItem-module--reviewContentContainer--338ae";
export var reviewImage = "ReviewItem-module--reviewImage--2a0ab";
export var reviewItem = "ReviewItem-module--reviewItem--a74e9";
export var reviewName = "ReviewItem-module--reviewName--f2e9e";
export var reviewTitle = "ReviewItem-module--reviewTitle--af229";
export var treatmentTitle = "ReviewItem-module--treatmentTitle--ad0a7";
export var videoOverLay = "ReviewItem-module--videoOverLay--5e4fe";
export var videoPopup = "ReviewItem-module--videoPopup--aa75b";
export var videoPopupOpen = "ReviewItem-module--videoPopupOpen--35f23";